<app-header [isScrolled]="true" [showMobilePropertyHeader]="true"></app-header>
<ion-content [dir]="languageService.dir()">
  @if (property()) {
  <div class="content-wrapper">
    @if (property().postStatus === 'Draft') {
      <div class="status-alert" [class.blue]="userService.auth.currentUser">
        <span class="icon">
          <ion-icon [src]="userService.auth.currentUser ? 'assets/icons/icon-alert.svg' : 'assets/icons/icon-warning.svg'"></ion-icon>
        </span>
        <span class="text">
          @if (!userService.auth.currentUser) {
            {{ 'property.unit_unavailable' | translate }}<a [routerLink]="['/user/login']">{{ 'property.sign_up_updates' | translate }}</a>
          } @else {
            {{ 'property.unit_unavailable_logged_in' | translate }}
          }
        </span>
      </div>
    }
    <div class="title">
      <div class="flex align-items-start ion-justify-content-between">
      <h1 [lang]="languageService.lang()" [dir]="languageService.dir()">{{ languageService.lang() === 'en' ? property().titleEn : property().titleAr }}
      </h1>
        @defer (hydrate on viewport) {
<!--          <div style="position: relative">-->

          @if (isBrowser()) {
          <ion-buttons class="ion-hide-sm-down share-buttons">
            <ion-button id="shareOnSm-trigger" color="danger" aria-label="Share property">
              <ion-icon name="share-social-outline"></ion-icon>
            </ion-button>
            @if (isWishlistLoading()) {
              <ion-spinner name="dots" color="dark"></ion-spinner>
            } @else {
              @if (!authService.user) {
                <ion-button id="wishlist-trigger" color="danger" aria-label="Add to wishlist">
                  <ion-icon [name]="'heart-outline'"></ion-icon>
                </ion-button>
              } @else {
                <ion-button (click)="updateWishList(property()._id)" color="danger" aria-label="Add to wishlist">
                  <ion-icon [name]="(isWishlistExists().exists || inWishList()) ? 'heart' : 'heart-outline'"></ion-icon>
                </ion-button>
              }
              <ion-popover trigger="wishlist-trigger" triggerAction="click">
                <ng-template>
                  <p style="margin: 0; padding: 10px"><a style="color: #AE1D59FF; text-decoration: underline;" [routerLink]="['/user/login']">Sign in</a> to use this feature</p>
                </ng-template>
              </ion-popover>
            }
          </ion-buttons>
          <ion-popover trigger="shareOnSm-trigger" triggerAction="click">
            <ng-template>
              <div class="ion-padding sm-buttons flex ion-justify-content-center">
                <div>
                  <p>Share on </p>
                  <ion-buttons>
                    <ion-button class="fb" [url]="generateUrl()" shareButton="facebook" aria-label="Share on Facebook"><ion-icon name="logo-facebook"></ion-icon></ion-button>
                    <ion-button class="x" color="dark" [url]="generateUrl()" shareButton="x" aria-label="Share on X"><ion-icon name="logo-x"></ion-icon></ion-button>
                    <ion-button class="whatsapp" [url]="generateUrl()" shareButton="whatsapp" aria-label="Share on WhatsApp"><ion-icon name="logo-whatsapp"></ion-icon></ion-button>
                    <ion-button (click)="copyUrl()" color="dark" aria-label="Copy link"><ion-icon name="copy-outline"></ion-icon></ion-button>
                  </ion-buttons>
                </div>
              </div>
            </ng-template>
          </ion-popover>

          }
<!--          </div>-->
        }
      </div>
      <span><ion-icon name="location-outline"></ion-icon>
        {{ property().address?.addressLine1En }}
            </span>
      <div class="_extra">
        <span>
          <ion-icon name="ticket-outline"></ion-icon> {{property().propertyNumber}}
        </span>
        @if (parentName) {
          <span>
            <ion-icon name="open-outline"></ion-icon> <a [routerLink]="['/p', parentId, property().catName?.nameEn, property().subCatName?.nameEn, 'a']">{{property().parentName}}</a>
          </span>
        } @else {
          @if (property()?.nameEn) {
          <span>
            <ion-icon name="ticket-outline"></ion-icon> {{property()?.nameEn}}
          </span>
          }
        }
      </div>
    </div>
    <app-property-image-gallery
      [isParent]="property().isParent"
      [subCatName]="property().subCatName"
      [labelText]="property().labelText ?? ''"
      [imagesList]="property().imageList" [videoUrl]="property().videoUrl ?? ''"></app-property-image-gallery>
    <ion-row class="main-row" >
      <ion-col size-lg="8" size="12">
        <div class="content">
<!--          @if (!property()?.isParent) {-->
          <div class="features-icon flex">
            <div class="tile">
              <ion-icon src="assets/icons/icon-square.svg"></ion-icon>
              <span>{{ property().floorArea | number: '1.0-0' }}{{ 'property.sq_m' | translate }}</span>
            </div>
            <div class="tile">
              <ion-icon src="assets/icons/icon-bed.svg"></ion-icon>
              <span>{{ property().bedsRange?.min ? (property().bedsRange?.min + '-' + property().bedsRange?.max) : property().beds }} {{ 'property.bedrooms' | translate }}</span>
            </div>
            <div class="tile">
              <ion-icon src="assets/icons/icon-bath.svg"></ion-icon>
              <span>{{ property().bathsRange?.min ? (property().bathsRange?.min + '-' + property().bathsRange?.max) : property().baths }} {{ 'property.bathrooms' | translate }}</span>
            </div>
            <div class="tile">
              <ion-icon src="assets/icons/icon-sofa.svg"></ion-icon>
              <span>{{ property().furnishing }}</span>
            </div>
          </div>
          <div class="divider-horizontal"></div>
<!--          }-->

          @if (property().utilitiesEn) {
          <h3>{{ 'property.amenities' | translate }}</h3>
          <div class="utilities" [lang]="languageService.lang()" [dir]="languageService.dir()" [innerHTML]="languageService.lang() === 'en' ? property().utilitiesEn : property().utilitiesAr"></div>
            <div class="divider-horizontal"></div>
          }

          <h3>{{property().isParent ? 'Property' : property().subCatName?.nameEn}} {{ 'property.description' | translate }}</h3>
          <div class="para" [class.show-more]="showMore" [lang]="languageService.lang()" [dir]="languageService.dir()" [innerHTML]="languageService.lang() === 'en' ? property().descriptionEn : property().descriptionAr"></div>
          <a class="read-more" (click)="showMore = !showMore">{{ showMore ? ('property.show_less' | translate) : ('property.read_more' | translate) }} <ion-icon name="chevron-forward-outline"></ion-icon></a>

          @if (property().isParent) {
            <app-property-units [parentId]="property()._id" [parentName]="property()?.nameEn ?? ''" [units]="property().childPropertiesDetails"></app-property-units>
          } @else {
            @if(parentId) {
              <div class="divider-horizontal"></div>
              <app-parent-property [parentId]="parentId"></app-parent-property>
            }
            @if (property().agentsList?.length) {
                  <div class="divider-horizontal"></div>
                  <app-meet-our-team [agents]="property().agentsList"></app-meet-our-team>
            }
<!---->
             <app-meet-us-in-person class="ion-hide-sm-down"></app-meet-us-in-person>
          }
        </div>
      </ion-col>
      <ion-col size-lg="4" size="12" class="ion-hide-sm-down">

        <app-price-card [property]="property()"></app-price-card>

      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col>
        <h3>{{ 'property.where_you_live' | translate }}</h3>
        <div class="map-wrapper">
<!--          <google-map-->
<!--            [height]="'100%'"-->
<!--            [width]="'100%'"-->
<!--            [options]="mapOptions"-->
<!--            [center]="coordinates"-->
<!--            [zoom]="17">-->

<!--            <map-directions-renderer-->
<!--            ></map-directions-renderer>-->

<!--            <map-advanced-marker-->
<!--              #marker="mapAdvancedMarker"-->
<!--              [position]="coordinates"-->
<!--              (mapClick)="openInfoWindow(marker)" />-->
<!--            <map-info-window>-->
<!--              <p>{{ property().titleEn }}</p>-->
<!--              <ion-button (click)="openGoogleMapsDirections(coordinates)">{{ 'property.show_direction' | translate }}</ion-button>-->
<!--            </map-info-window>-->
<!--&lt;!&ndash;            <map-marker (mapClick)="openInfoWindow(marker)" #marker [position]="coordinates"></map-marker>&ndash;&gt;-->
<!--          </google-map>-->
        </div>
        <div class="divider-horizontal"></div>

        <div class="ion-hide-sm-down">
          <h3>{{ 'property.similar_properties' | translate }}</h3>

          <div class="inner-property-wrapper">
            @for (property of properties; track property) {
              <app-property-card [property]="property" [innerCard]="true"></app-property-card>
            }
          </div>
        </div>

      </ion-col>
    </ion-row>

    <div class="divider-horizontal"></div>

    <app-b2b-section></app-b2b-section>

  </div>
  }

  <div class="mobile-property-wrapper ion-hide-sm-up">
    <h3>{{ 'property.similar_properties' | translate }}</h3>
    <swiper-container slides-per-view="1.3" space-between="10">
      @for (property of properties; track property) {
        <swiper-slide>
          <app-property-card [property]="property" [innerCard]="true"></app-property-card>
        </swiper-slide>
      }
    </swiper-container>
  </div>



  <app-footer></app-footer>
</ion-content>
@defer (hydrate on viewport) {
<ion-footer class="ion-hide-sm-up" [class.expanded]="footerExpanded">
  <ion-toolbar class="price">
    <div slot="start">
      <small>{{ 'property.rent_for' | translate }}</small>
      @if (property().priceRange?.min) {
        <span>{{ property().priceRange?.min | currency: currencyConvertService.localCurrency() + ' ' }} - {{ property().priceRange?.max | currency: currencyConvertService.localCurrency() + ' ' }}</span> <strong> {{ property().priceGroup }}</strong>
      } @else {
        <span>{{ property()?.price | currency: ' ' }} SAR</span> {{ property().priceGroup }}
      }
    </div>
  </ion-toolbar>
  <div class="footer-btn-wrapper">
    <ion-button (click)="propertyService.openEnquireModal(property())" class="btn-f" expand="fill">{{ 'property.book_now' | translate }}</ion-button>
    <ion-button [href]="'tel:' + whatsAppNumberFloating" fill="outline" color="dark" aria-label="Call us">
      <ion-icon name="call-outline"></ion-icon>
    </ion-button>
    <ion-button [href]="'https://wa.me/' + whatsAppNumberFloating" fill="outline" color="dark" aria-label="Contact us on WhatsApp">
      <ion-icon name="logo-whatsapp"></ion-icon>
    </ion-button>
  </div>
  <div class="divider-with-text"><span>{{ 'property.reach_support' | translate }}</span></div>
  <div class="buttons-wrapper">
    <ion-button color="dark" fill="outline" [href]="'tel:' + whatsAppNumberFloating" aria-label="Call us"><ion-icon name="call-outline"></ion-icon>
      {{ 'property.phone_call' | translate }}</ion-button>
    <ion-button color="dark" fill="outline" [href]="'https://wa.me/' + whatsAppNumberFloating" aria-label="Contact us on WhatsApp"><ion-icon name="logo-whatsapp"></ion-icon> {{ 'property.whatsapp' | translate }}</ion-button>
  </div>
</ion-footer>
}
